import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { SimpleHtmlModule } from 'src/app/components/simple-html/simple-html.module';
import { PageNewOrderComponent } from './page-new-order/page-new-order.component';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from 'src/app/app.routes';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { NgxMaskModule } from 'ngx-mask';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ToastrModule } from 'ngx-toastr';
import { NewOrderService } from './service/new-order.service';

@NgModule({
  declarations: [
    PageNewOrderComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    SimpleHtmlModule,
    BrowserModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    HttpModule,
    NgxMaskModule.forRoot(),
    PaginationModule.forRoot(),
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
    })
  ],
  providers: [
    NewOrderService
  ]
})
export class OrderModule { }
